module.exports = __webpack_public_path__ + "static/media/power-on.8ca76e5c.svg";